import { render } from "./ReadingScreen.vue?vue&type=template&id=1cf144fe"
import script from "./ReadingScreen.vue?vue&type=script&lang=js"
export * from "./ReadingScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__